import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function CookiePolicy() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Cookie Policy</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-gray-600 mb-6">
              <strong>Last Updated:</strong> January 4, 2026
            </p>
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">What Are Cookies?</h2>
                <p className="text-gray-600">
                  Cookies are small text files stored on your device when you visit our website. They help us provide a better user experience.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">How We Use Cookies</h2>
                <p className="text-gray-600">
                  We use cookies to remember your login session, preferences, and to analyze site traffic. This helps us improve BoardVoyage for all users.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Types of Cookies</h2>
                <p className="text-gray-600">
                  We use essential cookies for site functionality and analytics cookies to understand how users interact with our platform.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Managing Cookies</h2>
                <p className="text-gray-600">
                  You can control cookies through your browser settings. Note that disabling cookies may affect the functionality of BoardVoyage.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CookiePolicy;
